import * as HLF from "html-living-framework";
import * as PIXI from "pixi.js";
import {CHOOSE_STORY_NAME, IChooseStoryData} from "../data/IChooseStoryData";
import {Focusables} from "../gameobjects/Focusables";
import {VoiceOverManager} from "../managers/VoiceOverManager";
import {LoadScreen} from "./LoadScreen";

export class AbstractGameState extends HLF.State {

    public init(pSize: PIXI.Point, pData?: any) {
        super.init(pSize);

        Focusables.clear();
        Focusables.enabled = true;
    }

    public lockScreen() {
        this.interactiveChildren = false;
        Focusables.enabled = false;
    }

    public unlockScreen() {
        this.interactiveChildren = true;
        Focusables.enabled = true;
    }

    public gotoNextState<T>(name: string, data?: T) {
        VoiceOverManager.instance.stopVO();
        const steps = [
            HLF.TransitionStep.RemoveCurrent,
            HLF.TransitionStep.ShowLoadScreen,
            HLF.TransitionStep.LoadAssets,
            HLF.TransitionStep.HideLoadScreen,
            HLF.TransitionStep.AttachNewInFront,
            HLF.TransitionStep.UnloadAssets,
            HLF.TransitionStep.AnimNewIn,
        ];
        PubSub.publishSync(
            HLF.STATE_LOAD_STATE, data ?
                new HLF.StateToken({id: name, data}, LoadScreen.NAME, ...steps) :
                new HLF.StateToken(name, LoadScreen.NAME, ...steps),
        );
    }

    public gotoHomeState(data?: IChooseStoryData) {
        VoiceOverManager.instance.stopVO();
        const steps = [
            HLF.TransitionStep.RemoveCurrent,
            HLF.TransitionStep.ShowLoadScreen,
            HLF.TransitionStep.LoadAssets,
            HLF.TransitionStep.HideLoadScreen,
            HLF.TransitionStep.AttachNewInFront,
            HLF.TransitionStep.UnloadAssets,
            HLF.TransitionStep.AnimNewIn,
        ];
        PubSub.publishSync(
            HLF.STATE_LOAD_STATE, data ?
                new HLF.StateToken({id: CHOOSE_STORY_NAME, data}, LoadScreen.NAME, ...steps) :
                new HLF.StateToken(CHOOSE_STORY_NAME, LoadScreen.NAME, ...steps),
        );
    }
}
